import gql from 'graphql-tag';

export const REGISTER_MEMBER_TMP = gql`
    mutation(
        $email: String!,
        $email_confirmation: String!,
        $golf_group_code: String,
        $golf_code: String,
        $member_rank: Int,
        $token: String,
        $id: String,
        $companionId: ID
    ) {
        registerMemberTmp(
            email: $email
            email_confirmation: $email_confirmation
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            member_rank: $member_rank
            token: $token
            id: $id
            companionId: $companionId
        )
    }
`;

export const REGISTER_MEMBER = gql`
    mutation(
        $family_name: String!
        $given_name: String!
        $family_name_kana: String!
        $given_name_kana: String!
        $zipcode: String
        $address1: String
        $address2: String
        $birth_date: String!
        $mobile_number: String
        $gender: Int!
        $token: String!
        $password: String!
        $password_confirmation: String!
        $golf_group_code: String!
        $auth_code: String
    ) {
        registerMember(
            family_name: $family_name
            given_name: $given_name
            birth_date: $birth_date
            family_name_kana: $family_name_kana
            given_name_kana: $given_name_kana
            zipcode: $zipcode
            address1: $address1
            address2: $address2
            mobile_number: $mobile_number
            gender: $gender
            token: $token
            password: $password
            password_confirmation: $password_confirmation
            golf_group_code: $golf_group_code
            auth_code: $auth_code
        ) {
            accessToken
        }
    }
`;

export const CHECK_TMP_MEMBER = gql`
    query($token: String!) {
        checkTmpMemberToken(token: $token) {
            email
            family_name
            given_name
            birth_date
            mobile_number
            gender
            tmp_member_no
        }
    }
`;

export const GET_SOCIAL_AUTH_URL_FOR_REGISTER = gql`
    query($golf_group_code: String, $golf_code: String, $member_rank: Int) {
        getSocialAuthUrl(
            providerName: line,
            operationType: register,
            golf_group_code: $golf_group_code,
            golf_code: $golf_code,
            member_rank: $member_rank
        ) {
            url
        }
    },
`;

export const REGISTER_MEMBER_TMP_USING_SOCIAL = gql`
    mutation (
        $queryId: String
        $queryToken: String
    ) {
        registerMemberTmpUsingSocial(
            providerName: line
            queryId: $queryId
            queryToken: $queryToken
        ) {
            token
        }
    }
`;
